/* eslint-disable @typescript-eslint/no-require-imports */
export const sinistresList = [
    {
      title: 'Auto Moto',
      source: require('../../../ressources/images/assurance_auto_moto_v1.png'),
    },
    {
      title: 'Famille',
      source: require('../../../ressources/images/assurance_famille_v1.png'),
    },
    {
      title: 'Habitation',
      source: require('../../../ressources/images/assurance_habitation_v1.png'),
    },
    {
      title: 'Accident et voyage',
      source: require('../../../ressources/images/accident-voyage.png'),
    },
];
